import React, { FC } from "react";
import { Box, makeStyles, Typography, Grid } from "@material-ui/core";
import { Link, useLocation } from "react-router-dom";
import { Wave } from "./Wave";

export const Footer: FC = () => {
  const { pathname } = useLocation();
  const waveRoutes = ["/", "/results"];
  const classes = styles();
  return (
    <Box display="flex" flex={0} flexDirection="column" position="relative">
      {waveRoutes.includes(pathname) && <Wave />}
      <Box
        display="flex"
        flex={0}
        flexDirection="column"
        alignItems="center"
        height="40px"
        padding={4}
        style={{ backgroundColor: "#f2f2f2" }}
      >
        <Typography className={classes.copyright}>
          © Copyright Celestion {new Date().getFullYear()}
        </Typography>
        <Box
          display="flex"
          justifyContent="center"
          paddingTop={1}
          width="100%"
          // maxWidth="500px"
        >
          <Grid container justifyContent="center" direction="row">
            <Grid item xs={12} sm={2} md={1}>
              <Box justifyContent="center" display="flex">
                <Link className={classes.text} to="/terms">
                  Terms & Conditions
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={2} md={1}>
              <Box justifyContent="center" display="flex">
                <Link className={classes.text} color="inherit" to="/privacy">
                  Privacy & Cookie Policy
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={2} md={1}>
              <Box justifyContent="center" display="flex">
                <Link
                  className={classes.text}
                  color="inherit"
                  to="/acceptableUse"
                >
                  Acceptable Use Policy
                </Link>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

const styles = makeStyles(() => ({
  copyright: {
    color: "grey",
    textDecoration: "none",
    fontSize: "0.8rem",
    padding: 10,
  },
  text: {
    textAlign: "center",
    color: "grey",
    textDecoration: "none",
    fontSize: "0.6rem",
    padding: 10,
    "&:hover": { color: "black" },
  },
}));
